import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import URLHelpers from '../components/shared/url_helpers';

const lazyOnboardingContainer = async () => ({
  Component: (await import(
    /* webpackChunkName: 'onboarding' */
    '../onboarding/progressive_onboarding_container'
  )).default,
});

// v7 child routes must use relative paths (the v3 tree allowed absolute ones)
const relative = (path) => path.replace(/^\//, '');

const OnboardingRoute = (
  <Route
    key={URLHelpers.onboardingPath}
    path={relative(URLHelpers.onboardingPath)}
    lazy={lazyOnboardingContainer}
  />
);

const OnboardingCompleteRoute = (
  <Route
    key={URLHelpers.onboardingCompleteShopDetailsPath}
    path={relative(URLHelpers.onboardingCompleteShopDetailsPath)}
    lazy={lazyOnboardingContainer}
  />
);

const OnboardingBegin3DS1Route = (
  <Route
    key={URLHelpers.onboardingBegin3DS1}
    path={relative(URLHelpers.onboardingBegin3DS1)}
    lazy={lazyOnboardingContainer}
  />
);

const OnboardingRoutes = [
  OnboardingRoute,
  OnboardingCompleteRoute,
  OnboardingBegin3DS1Route,
];

export default OnboardingRoutes;
